module.exports = __webpack_public_path__ + "static/media/service-03.65c8650e.webm";